import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {TextField, FieldReturn} from '../../types'

const defaultProps: Partial<TextField> = {
  rows: 4,
}

export const text = (props?: TextField, mergeProps?: Partial<TextField>): FieldReturn =>
  field('text', mergeConfig('text', props, mergeProps, defaultProps))
